import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserSessionService } from '../../app-user-session.service';
import { ModalService } from '../../blocks';
import { PatVisitStaff } from '../../inpatient/inpatient-reservation/inpatient-reservation.service';
import { ServiceHistoryComponent } from '../../orders/service-history';
import { PortalSchedulingManagementService } from '../../outpatient/portal-scheduling-management/portal-scheduling-management.service';
import { RegPatService } from '../../pricing/reg-pat-service/reg-pat-service';
import { readTextFile } from '../emr-general-methods';
import { IRegPatServiceDevices } from '../emr-medical-sheet/emr-physiotherapy-sheet.service';
import { PatientSessionDataService } from './patient-session-data.service';
import { CancelServiceComponent } from '../../pricing/cancel-service/cancel-service.component';

@Component({
  selector: 'patient-session-data',
  templateUrl: './patient-session-data.component.html',
  styleUrls: ['./patient-session-data.component.css']
})
export class PatientSessionDataComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @Input() matrixMode: boolean;
  @Input() serviceType: number;
  @Input() sessionSerial: number;
  dynamicComponent: any;
  @ViewChild('popup') content: any;
  sessionObj: any = <any>{};
  jsonFormSetting: any = <any>{};
  deviceReadBefore: any[] = [];
  deviceReadAfter: any[] = [];
  patientService: any[] = [];
  devices: any[] = [];
  nursingList: any[] = [];
  bodyParts: any[] = [];

  constructor(
    public translate: TranslateService,
    public _patientScheduling: PortalSchedulingManagementService,
    private _modalService: ModalService,
    private _userSessionService: UserSessionService,
    private _patientSession: PatientSessionDataService) { }

  ngOnInit() {
    this.getMatrixSessionData$();
    this.jsonFormSetting = JSON.parse(readTextFile('../../../setting/patientSessionData_1.json')) ? JSON.parse(readTextFile('../../../setting/patientSessionData_1.json')) : {};
  }

  getMatrixSessionData$() {
    this._userSessionService.subscribeToKey$('MatrixSessionData')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys && keys.value) {
          this.sessionObj = keys.value;
          this.getPatientSessionData({ regPatServiceSerial: this.sessionObj.selectRegPatServiceSerial ? this.sessionObj.selectRegPatServiceSerial : this.sessionObj.regPatServiceSerial, serviceType: this.sessionObj.resourceType, patCode: this.sessionObj.patCode, ccCallSerial: this.sessionObj.ccCallSerial });
        }
      });
  }


  getPatientSessionData(parms: RegPatService) {
    this._patientSession.getSessionData(parms)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res && Object.keys(res).length > 0) {
          this.patientService = res.data && res.data.length ? res.data : [];
          this.devices = res.data1 && res.data1.length ? res.data1 : []; // have add / edit / delete
          this.nursingList = res.data2 && res.data2.length ? res.data2 : []; // have add / edit / delete
          this.bodyParts = res.data3 && res.data3.length ? res.data3 : [];
        }
      })
  }

  ///////////////////////////////////// staff
  addNurses(nurses: any[]) {
    let length = this.nursingList.length;
    if (nurses && nurses.length > 0) {
      nurses.forEach(nurse => {
        if (!this.nursingList.find(ser => ser.empId === nurse.code)) {
          length += 1;
          nurse['serial'] = length * -1;
          nurse['empId'] = nurse.code;
          nurse['empCode'] = nurse.customCode;
          nurse['medRoleCode'] = 5;
          nurse['empNameAr'] = nurse.nameAr;
          nurse['empNameEn'] = nurse.nameEn;
          this.nursingList = this.nursingList.concat(nurse);
        }
      });
    }
  }
  isCollapsedservce: boolean = true;

  toggleCollapseservices() {
    this.isCollapsedservce = !this.isCollapsedservce;
  }

  isCollapsedservcenurse: boolean = true;

  toggleCollapsenurse() {
    this.isCollapsedservcenurse = !this.isCollapsedservcenurse;
  }
  deleteNurse(nurse: PatVisitStaff) {
    if (nurse && nurse.serial > 0) {
      this._modalService.activeDelMes(nurse.empNameAr, nurse.empNameEn).then(responseOK => {
        if (responseOK) {
          this._patientSession.deleteInPatientStaff(nurse.serial)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(res => {
              if (res && res.returnFlag)
                this.getPatientSessionData({ regPatServiceSerial: this.sessionObj.selectRegPatServiceSerial, serviceType: this.sessionObj.resourceType });
            });
        }
      });
    } else {
      let ind = this.nursingList.indexOf(nurse);
      this.nursingList.splice(ind, 1);
    }
  }

  saveStaffItems() {
    this.nursingList.forEach(el => {
      el.visitSerial = this.sessionObj.visitSerial;
      el.regPatServiceSerial = this.sessionObj.regPatServiceSerial;
      el.startDate = new Date();
      el.endDate = new Date();
      el.regPatServiceSerialAr = this.patientService[0].serviceNameAr;
      el.regPatServiceSerialEn = this.patientService[0].serviceNameEn;
      el.regPatMedicalStepsSerial = this.sessionObj.regPatMedicalStepsSerial;
    });
    this._patientSession.addInpatientStaff(this.nursingList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if (res && res.returnFlag)
          this.getPatientSessionData({ regPatServiceSerial: this.sessionObj.selectRegPatServiceSerial, serviceType: this.sessionObj.resourceType });

      },
        error => console.log(error),
        () => {
          this.getMatrixSessionData$();
        });
  }

  //////////////////////////////// devices
  addServiceDevices(devicesList: any[]) {
    let length = this.devices.length;
    if (devicesList && devicesList.length > 0) {
      devicesList.forEach(device => {
        if (!this.devices.find(dev => dev.resourceId === device.code)) {
          length += 1;
          let deviceObj: IRegPatServiceDevices = {
            serial: length * -1,
            resourceId: device.code,
            regPatServiceSerial: this.sessionObj.regPatServiceSerial,
            deviceNameAr: device.nameAr,
            deviceNameEn: device.nameEn,
            regPatMedicalStepsSerial: this.sessionObj.regPatMedicalStepsSerial


          }
          this.devices = this.devices.concat(deviceObj);
        }
      });
    }
  }

  deleteDevice(device: IRegPatServiceDevices) {
    if (device && device.serial > 0) {
      this._modalService.activeDelMes(device.deviceNameAr, device.deviceNameEn).then(responseOK => {
        if (responseOK) {
          this._patientSession.deleteRegpatServiceDevices(device)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(res => {
              if (res && res.returnFlag)
                this.getPatientSessionData({ regPatServiceSerial: this.sessionObj.selectRegPatServiceSerial, serviceType: this.sessionObj.resourceType });
            });
        }
      });
    } else {
      let ind = this.devices.indexOf(device);
      this.devices.splice(ind, 1);
    }
  }

  saveServiceDevices() {
    // for(let i=0; i< this.devices.length;i++){
    // this.devices[i].deviceReadBefore= this.deviceReadBefore,
    // this.devices[i].deviceReadAfter= this.deviceReadAfter
    // }
    if (this.devices && this.devices.length > 0)
      this._patientSession.addRegpatServiceDevices(this.devices)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(res => {
          if (res && res.returnFlag)
            this.getPatientSessionData({ regPatServiceSerial: this.sessionObj.selectRegPatServiceSerial, serviceType: this.sessionObj.resourceType });
        });
  }

  onIconActionClick(row: any) {

    if (row) {
      this.cancelClicked(row);
    }
  }
  cancelClicked(data: any) {
    //if (this.sendMessageFlag) {
    data.sendMessageFlag = true
    data.type = 10;
    //}//الالغاء حجززات مركز الاتصالت
    this.dynamicComponent = CancelServiceComponent;
    this.content.openModal("CancelServiceComponent", "Reservations", data);
  }

  //-------------------save btns   
  onBtnsClicked(e: number, type: number) {
    switch (e) {
      case 1:
        if (type == 1) {
          this.saveServiceDevices();
        } else {
          this.saveStaffItems();
        }
        break;
      case 2132:
        this.showhistorypopup();
      default:
        console.warn('No Button Action');
        break;
    }
  }
  showhistorypopup() {
    this.dynamicComponent = ServiceHistoryComponent;
    this._userSessionService.setSessionKey('ServiceHistoryComponent', this.sessionObj);
    this.content.openModal("ServiceHistoryComponent", "ERPatList", this.sessionObj);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  onpopupClose(e: any) {
    this.getPatientSessionData({ regPatServiceSerial: this.sessionObj.selectRegPatServiceSerial ? this.sessionObj.selectRegPatServiceSerial : this.sessionObj.regPatServiceSerial, serviceType: this.sessionObj.resourceType, patCode: this.sessionObj.patCode, ccCallSerial: this.sessionObj.ccCallSerial });

  }
}
